import { endPoint } from "./base.config";

export const queue = {
  addForwardOldVoucher: `${endPoint}queue/addForwardOldVoucher`,
  lastTimeSendReminder: `${endPoint}queue/lastTimeSendReminder`,
}